class GlobalInfo {
  private static _instance: GlobalInfo;
  protected instanceName: string;
  protected theme: string;

  constructor() {
    this.instanceName = '';
    this.theme = '';
  };

  public static get Instance() {
    return this._instance || (this._instance = new this());
  };

  /**
   * InstanceName getter
   */
  getInstanceName = (): string => {
    return this.instanceName;
  };

  /**
   * Returns true if it's default theme(light) false if it's dark theme.
   */
  getThemeType() {
    return !this.theme?.includes('dark');
  };

  /**
   * InstanceName setter
   */
  setInstanceName = (instanceName: string): void => {
    this.instanceName = instanceName;
  };

  setTheme = (theme: string) => {
    this.theme = theme;
  };
}

const GlobalInfoProvider = GlobalInfo.Instance;
export default GlobalInfoProvider;


